import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addSuccessMessage } from "../../../Messages/successMessages";
import { bidPackUrls } from "../../../URL/ApplicationUrls";
import { bidPackObjectName } from "../BidPack";
import { BidPackWriteRequest } from "../BidPackWriteRequest";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useAddBidPack = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (bidPack: BidPackWriteRequest) => {
      return axios.post<number>(bidPackUrls.base.apiUrl, bidPack);
    },
    onSuccess: async (response: AxiosResponse) => {
      navigate(bidPackUrls.uiPathForBidPackWithId(response.data));
      toast.success(addSuccessMessage(response.data, bidPackObjectName));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
